import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ContextMenuComponent } from './context-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [ContextMenuComponent],
  providers: [],
  exports: [ContextMenuComponent]
})

export class ContextMenuModule {

}
